import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { BillingFeatureAccessService } from '../billing/billing-feature-access.service';

function normalizeFeatures(value: unknown): string[] {
  if (!Array.isArray(value)) {
    return [];
  }
  return value
    .filter((item): item is string => typeof item === 'string')
    .map((item) => item.trim().toUpperCase())
    .filter((item) => item.length > 0);
}

export const featureGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const featureAccess = inject(BillingFeatureAccessService);

  const requiredFeatures = normalizeFeatures(route.data?.['features']);
  if (requiredFeatures.length === 0) {
    return true;
  }

  return featureAccess.ensureCurrentCompanyFeatures().pipe(
    map((snapshot) => {
      if (!snapshot) {
        return router.createUrlTree(['/403']);
      }
      if (featureAccess.hasAllFeatures(requiredFeatures, snapshot)) {
        return true;
      }
      return router.createUrlTree(['/403']);
    }),
    catchError(() => of(router.createUrlTree(['/403']))),
  );
};
